export const getCounties = async (zipCode) => {  
  const key = "b9bfa67637ec4e58b8d929e649d0948f";
  const country = "us";

 const COUNTY_OVERRIDES = {
  // --- California ---
  "90001": "Los Angeles County",
  "90002": "Los Angeles County",
  "90003": "Los Angeles County",
  "94102": "San Francisco County",
  "94103": "San Francisco County",
  "95630": "Sacramento County", // sometimes returns El Dorado

  // --- New York ---
  "10001": "New York County",
  "10002": "New York County",
  "10003": "New York County",
  "11201": "Kings County", // Brooklyn
  "10451": "Bronx County",
   "11555": "Nassau County",

  // --- Florida ---
  "33101": "Miami-Dade County",
  "33125": "Miami-Dade County",
  "33012": "Miami-Dade County",
  "33950": "Charlotte County", // returns Lee sometimes

  // --- Texas ---
  "77001": "Harris County",
  "77002": "Harris County",
  "75001": "Dallas County",
  "75002": "Collin County", // sometimes says Dallas

  // --- Georgia ---
  "30301": "Fulton County",
  "30303": "Fulton County",
  "30032": "DeKalb County", // sometimes returns Fulton

  // --- Illinois ---
  "60601": "Cook County",
  "60602": "Cook County",
  "60010": "Cook County", // sometimes returns Lake County
  "60540": "DuPage County",

  // --- Arizona ---
  "85001": "Maricopa County",
  "85002": "Maricopa County",
  "85701": "Pima County",

  // --- Nevada ---
  "89101": "Clark County",
  "89102": "Clark County",
  "89701": "Carson City", // not Ormsby County

  // --- New Jersey ---
  "07086": "Hudson County",
  "07305": "Hudson County",
  "08831": "Middlesex County", // often misclassified

  // --- Pennsylvania ---
  "19104": "Philadelphia County",
  "19067": "Bucks County", // sometimes returns Mercer County (NJ)
  "15213": "Allegheny County",

  // --- Michigan ---
  "48201": "Wayne County",
  "48067": "Oakland County",

  // --- Colorado ---
  "80202": "Denver County",
  "80301": "Boulder County",

  // --- Washington ---
  "98101": "King County",
  "98052": "King County",

  // --- Virginia ---
  "22101": "Fairfax County",
  "20147": "Loudoun County",

  // --- Maryland ---
  "20814": "Montgomery County",
  "21201": "Baltimore City",

  // --- Massachusetts ---
  "02115": "Suffolk County",
  "02138": "Middlesex County",
};


  try {
    const response = await fetch(
      `https://api.opencagedata.com/geocode/v1/json?q=${zipCode}&key=${key}&countrycode=${country}`, 
      { method: "GET" }
    );
    
    const data = await response.json();

    if (data.status.code === 200 && data.total_results > 0) {
      let county = data.results[0].components.county || "";
      const timezone = data.results[0].annotations?.timezone?.name || "";
      const city = data.results[0].components._normalized_city || "";
      // ---- Step 2: Use correct county if override exists ----
      if (COUNTY_OVERRIDES[zipCode]) {
        county = COUNTY_OVERRIDES[zipCode];
      }

      return { county, timezone, city };
    } else {
      return { county: "", timezone: "" , city: ""};
    }
  } catch (e) {
    console.error("Error fetching location details:", e);
    return { county: "", timezone: "" };
  }
};
